import React, { useState, Fragment } from "react";
import { Helmet } from "react-helmet";
import ActivePage from "../../partials/active-page";
import { Redirect } from "react-router-dom";
import StaffProfileAssignPatient from "./partials/StaffProfileAssignPatient";
import NewAssignmentList from "./partials/NewAssignmentList";
import { appName } from "../../app.json";
import { useLazyQuery, useMutation } from "@apollo/react-hooks";
import { GET_PATIENT_NHS } from "../../queries/patient.query";
import { Staff as STAFFQUERY } from "../../queries/staff.query";
import AlertMessage from "../../partials/alertMessage";
import LoadingSpinner from "../../partials/loading";
import auth from "../../providers/Auth.Provider";

const AssignPatient = ({ match, location }) => {
	const [activeStaff] = useState(
		location && location.state && location.state.activeStaff
	);
	const [newPatientList, SetNewPatientList] = useState([]);
	const [hcn, SetHCN] = useState();
	const [message, SetMessage] = useState();

	const title = "Assign Patient to Staff";
	const pages = [
		{
			title,
			path: match.path
		}
	];
	const { IsAuthenticationError, LogOut } = auth.authProvider;

	const [GetPatient, { loading }] = useLazyQuery(GET_PATIENT_NHS, {
		variables: { hcn },
		onCompleted: data => {
			const newList = [...newPatientList];
			const patient = data.GetPatientByNumber.doc;
			newList.unshift(patient);
			SetNewPatientList(newList);
		},
		onError: err => {
			if (IsAuthenticationError(err.message)) LogOut();
			SetMessage(err.message);
		}
	});

	// Mutation to save Assigned patients to database
	const [
		AssignPatient,
		{ loading: aLoading, error: aError, data: aData }
	] = useMutation(STAFFQUERY.MUTATION.ASSIGNPATIENTS);

	// Handler
	const HandlePatientRemoval = patientId => {
		const patientList = newPatientList;

		patientList.splice(
			newPatientList.findIndex(e => e.id === patientId),
			1
		);
		SetNewPatientList(patientList);
	};

	const HandlePatientAssignment = async () => {
		if (newPatientList) {
			await AssignPatient({
				variables: {
					id: activeStaff.id,
					patients: newPatientList.map(e => e.id)
				}
			});
		}
	};

	if (!activeStaff) return <Redirect to="/home/staffing/list" />;
	return (
		<Fragment>
			<Helmet>
				<title>
					{title} | {appName}
				</title>
				<link
					href="../../main/formlayout.css"
					rel="stylesheet"
					type="text/css"
				/>
			</Helmet>
			<ActivePage title={title} pages={pages} />
			<div className="row">
				<div className="col-md-4">
					<div className="card">
						<div className="card-body">
							{/* <!-- BEGIN PROFILE SIDEBAR --> */}
							<StaffProfileAssignPatient
								staff={activeStaff && activeStaff}
							/>
						</div>
					</div>
				</div>
				<div className="col-md-8">
					<div className="row">
						<div className="col-md-12">
							<div className="card">
								{/* Error Message */}
								<AlertMessage message={message} failed={true} />
								<div className="px-5 py-2">
									<form
										onSubmit={e => {
											e.preventDefault();
											if (hcn) GetPatient();
										}}
									>
										<div className="input-group">
											<input
												type="search"
												name="searchInput"
												required
												onChange={e => {
													SetHCN(e.target.value);
												}}
												placeholder="Enter Patient's NHS Id"
												className="form-control"
												style={{
													height: "50px",
													border: "none"
												}}
											/>
											<span className="input-group-btn">
												<button
													type="submit"
													className="mdl-button mdl-js-button mdl-button--raised mdl-js-ripple-effect m-b-10 btn-circle btn-success ml-2"
													style={{
														height: "44px",
														right: 0
													}}
												>
													<i className="material-icons">
														person_add
													</i>{" "}
													Add Patient
												</button>
											</span>
										</div>
									</form>
								</div>
								<LoadingSpinner loading={loading} />
							</div>
						</div>
					</div>
					{newPatientList.length > 0 && (
						<div className="row">
							<div className="col-md-12">
								<div className="card">
									<div className="card-head">
										<header>Newly Assigned Patients</header>
										<div className="tools">
											<a
												className="t-collapse btn-color fa fa-chevron-down"
												href="javascript:;"
											></a>
										</div>
									</div>
									<div className="card-body center">
										{aError && (
											<AlertMessage
												message={aError.message}
												failed={true}
											/>
										)}
										{aData && (
											<AlertMessage
												message={
													aData &&
													aData.AssignPatientsToStaff
														.message
												}
											/>
										)}

										{/* <!-- List of assigned patients --> */}
										<NewAssignmentList
											patients={newPatientList}
											onAssign={HandlePatientAssignment}
											onRemove={HandlePatientRemoval}
										/>

										{aLoading && (
											<LoadingSpinner
												loading={aLoading}
											/>
										)}
									</div>
								</div>
							</div>
						</div>
					)}

					{newPatientList.length === 0 && (
						<div
							className="card center pt-5"
							style={{ minHeight: "280px" }}
						>
							<h4 className="text-danger">
								No new Patient assigned Yet!
							</h4>
						</div>
					)}
				</div>
			</div>
		</Fragment>
	);
};

export default AssignPatient;
